<template>
  <!-- 上方title -->
  <div>
    <cus-button text="交易資訊" color="darkBlue" :isButton="false" style="padding: 0" fontSize="normal"></cus-button>
  </div>
  <!-- 下方content -->
  <div class="wrap">
    <div class="trade-box">
      <div class="content-multiple">
        <p>載具</p>
        <div v-if="getCarrier?.length > 0">
          <p
            v-for="(item, index) in getCarrier"
            :key="index"
            :style="
              item.invoice_carrier_type === 'citizen_digital_certificate' ? 'font-size:1.8rem; line-height:2.9rem' : ''
            "
          >
            {{ mapValue[item.invoice_carrier_type]?.label }} {{ item.code }}
          </p>
        </div>
        <div v-else>
          <p>無</p>
        </div>
      </div>
      <div class="content">
        <p>統編</p>
        <p>{{ getTax || '無' }}</p>
      </div>
      <div class="content">
        <p>發票模式</p>
        <div class="invoice-type d-flex">
          <div :class="['switch', getInvoiceMode === 1 ? 'right' : '']"></div>
          <p :class="getInvoiceMode === 2 ? 'select' : ''" @click="handleChangeMode(2)">手開發票</p>
          <p :class="getInvoiceMode === 1 ? 'select' : ''" @click="handleChangeMode(1)">電子發票</p>
        </div>
      </div>
    </div>
    <div class="trade-box">
      <div v-if="!getDayungsPayment" class="empty">
        <p>尚無資訊</p>
      </div>
      <div class="content content-title">
        <p>大苑子支付</p>
        <p>金額</p>
      </div>
      <div v-if="getDayungsPayment" class="card-list">
        <div v-if="getDayungsPayment.want_card" class="content">
          <p>旺卡餘額</p>
          <p>{{ getPayStatus ? getDayungsPayment.want_card.balance : getBalance('want_card') }}</p>
        </div>
        <div v-if="getDayungsPayment.cash_card" class="content">
          <p>現金卡餘額</p>
          <p>{{ getPayStatus ? getDayungsPayment.cash_card.balance : getBalance('cash_card') }}</p>
        </div>
        <div v-if="getDayungsPayment.want_card_point" class="content">
          <p>黃金點數餘額</p>
          <p>{{ getPayStatus ? getDayungsPayment.want_card_point.balance : getBalance('want_card_point') }}</p>
        </div>
      </div>
    </div>
    <div class="trade-box">
      <div v-if="!getPaidList?.length > 0" class="empty">
        <p>尚無資訊</p>
      </div>
      <div class="content content-title">
        <p>付款方式</p>
        <p>金額</p>
      </div>
      <div v-if="getPaidList?.length > 0" class="paid-list">
        <div v-for="(item, index) in getPaidList" :key="index" class="content">
          <p>{{ item.label }}</p>
          <p>{{ item.amount }}</p>
        </div>
      </div>
      <cus-button
        v-if="getPaidList?.length > 0"
        text="清空"
        color="white"
        style="padding: 0; min-height: auto"
        @click="handleClear"
        :disabled="checkPaymentPermission()"
      ></cus-button>
    </div>
    <div class="amount">
      <div class="unpaid">
        <div class="content">
          <p>未收</p>
        </div>
        <div class="content">
          <p :style="computeUnpaid.toString().length > 5 ? 'font-size: 3.6rem' : ''">{{ computeUnpaid }}</p>
        </div>
      </div>
      <div class="paid">
        <div class="content">
          <p :style="computePaid.toString().length > 5 ? 'font-size: 2rem' : ''">已收</p>
          <p :style="computePaid.toString().length > 5 ? 'font-size: 2rem' : ''">{{ computePaid }}</p>
        </div>
        <div class="content">
          <p :style="computePaid.toString().length > 5 ? 'font-size: 2rem' : ''">找零</p>
          <p :style="change.toString().length > 5 ? 'font-size: 2rem' : ''">{{ change }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useGetters, useMutations } from '@/utils/mapStore';
import { getAmount } from '@/utils/amount';
import { mapValue } from '@/utils/define';
import { getCurrentInstance } from 'vue';
export default {
  name: 'trade-info',
  setup() {
    const { proxy } = getCurrentInstance();
    //取得資料
    const { getCarrier, getTax, getInvoiceMode, getPaidList, getPayStatus } = useGetters('checkout', [
      'getCarrier',
      'getTax',
      'getInvoiceMode',
      'getPaidList',
      'getPayStatus',
    ]);
    const { computePaid, computeUnpaid, change, getBalance } = getAmount();
    const getDayungsPayment = useGetters('member', ['getDayungsPayment']);
    //切換發票模式
    const SET_INVOICE_MODE = useMutations('checkout', ['SET_INVOICE_MODE']);
    const handleChangeMode = (type) => {
      switch (type) {
        case 1:
          SET_INVOICE_MODE(1);
          break;
        case 2:
          if (getCarrier.value?.length > 0) {
            proxy
              .$confirm({
                content: '若選擇手開發票，發票將無法存入載具，<br/>是否仍要繼續？',
                confirmText: '繼續',
              })
              .then(() => {
                SET_INVOICE_MODE(2);
              })
              .catch((e) => e);
          } else {
            SET_INVOICE_MODE(2);
          }
          break;
      }
    };
    //清空
    const CLEAR_PAID_LIST = useMutations('checkout', ['CLEAR_PAID_LIST']);
    const handleClear = () => {
      CLEAR_PAID_LIST();
    };
    //清空disable
    const getPaymentPermission = useGetters('checkout', ['getPaymentPermission']);
    const checkPaymentPermission = () => {
      let is_all_false = true;
      Object.keys(getPaymentPermission.value).forEach((item) => {
        if (getPaymentPermission.value[item].is_enable) is_all_false = false;
      });
      return is_all_false;
    };
    return {
      mapValue,
      getCarrier,
      getTax,
      getInvoiceMode,
      getPaidList,
      getPayStatus,
      getDayungsPayment,
      handleChangeMode,
      computePaid,
      computeUnpaid,
      change,
      getBalance,
      handleClear,
      checkPaymentPermission,
    };
  },
};
</script>
<style lang="scss" scoped>
.wrap {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: minmax(15%, max-content) minmax(15%, max-content) auto 14%;
  grid-gap: 8px;
  font-size: 2rem;
}

.empty {
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: $color-light-mask;
  p {
    color: #fff;
    font-size: 1.8rem;
    text-align: center;
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.content {
  @include flex-between-center;
  &-title {
    border-bottom: 1px solid $color-gray-10;
    padding-bottom: 5px;
  }
  margin: 3px 0;
}

.content-multiple {
  display: flex;
  justify-content: space-between;
  text-align: right;
  margin: 3px 0;
}

.trade-box {
  @include white-bg;
  width: 100%;
  position: relative;
  &:nth-of-type(1) {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 8px 16px;
    .invoice-type {
      position: relative;
      background-color: $color-gray-6;
      border-radius: 18px;
      p {
        font-size: 1.8rem;
        color: $color-blue;
        padding: 3px 12px;
        cursor: pointer;
        z-index: 2;
        transition: 0.2s;
      }
      p.select {
        color: #fff;
      }
      .switch {
        position: absolute;
        z-index: 1;
        width: 50%;
        height: 100%;
        background-color: $color-blue;
        border-radius: 18px;
        left: 0;
        transition: 0.2s;
      }
      .switch.right {
        left: 50%;
      }
    }
  }
  &:nth-of-type(2) {
    padding: 10px 16px;
    display: grid;
    grid-template-rows: 45px auto;
  }
  &:nth-of-type(3) {
    padding: 10px 16px;
    display: grid;
    grid-template-rows: 45px auto 60px;
  }
}

.amount {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  grid-gap: 8px;
  color: #fff;
  font-size: 2.4rem;
  line-height: 4vh;
  @mixin base-style {
    border-radius: 4px;
    padding: 0 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .unpaid {
    background-color: $color-red-70;
    @include base-style;
    div:nth-of-type(2) {
      font-size: 4.2rem;
    }
  }
  .paid {
    background-color: $color-yellow-70;
    @include base-style;
  }
}
</style>
